export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const STOCKS_DATA_URL = process.env.REACT_APP_STOCKS_DATA_URL;

/**
 * Login host, separate so OTP can be sent by a deployed API (it publishes to SNS and
 * cannot run locally) while the rest of the app talks to a local backend.
 * Defaults to API_BASE_URL, so deployed builds need no extra variable.
 */
export const AUTH_API_BASE_URL =
  process.env.REACT_APP_AUTH_API_BASE_URL || API_BASE_URL;

export const API_URLS = {
  THEMES: `${API_BASE_URL}/themes`,
  SUBSCRIBER: `${API_BASE_URL}/subscriber`,
  SUBSCRIBER_STOCK: (phoneNumber: string) =>
    `${API_BASE_URL}/subscriber/${encodeURIComponent(phoneNumber)}/stock`,
  SUBSCRIBER_NOTIFICATION_PREFERENCES: `${API_BASE_URL}/subscriber/notification-preferences`,
  SUBSCRIBER_COVERAGE: `${API_BASE_URL}/subscriber/coverage`,
  SUBSCRIBER_DEACTIVATE: `${API_BASE_URL}/subscriber/deactivate`,
  SUBSCRIBER_ACTIVATE: `${API_BASE_URL}/subscriber/activate`,
  OTP: `${AUTH_API_BASE_URL}/otp`,
  TOKEN: `${AUTH_API_BASE_URL}/token`,
  PLANS: `${API_BASE_URL}/plans`,
  PLANS_BY_COUNTRY: (countryCode: string) => `${API_BASE_URL}/plans/${countryCode}`,
  PAY_VERIFY: `${API_BASE_URL}/pay/verify`,
  PAY_CREATE_ORDER: `${API_BASE_URL}/pay/createorder`,
  COUPON_VALIDATE: `${API_BASE_URL}/coupons/validate`,
  COUPON_DETAILS: (couponCode: string) => `${API_BASE_URL}/coupons/${couponCode}`,
  DESCRIPTORS: `${API_BASE_URL}/api/descriptors`,
  STOCKS_DATA_JSON: `${STOCKS_DATA_URL}/stocks_data.json`,
  WRAPS: `${API_BASE_URL}/wrap`,
  WRAP_BY_DATE: (date: string) => `${API_BASE_URL}/wrap/${encodeURIComponent(date)}`,
  WRAP_FEEDBACK: (date: string) =>
    `${API_BASE_URL}/wrap/${encodeURIComponent(date)}/feedback`,
}; 